/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch } from 'react-redux';
import { ID } from '../../../../../../../_metronic/helpers';
import { MenuComponent } from '../../../../../../../_metronic/assets/ts/components';
import { TallyLedger } from '../../core/_requests';
import { setMessage } from '../../../../../../../store/alertMessage/actions';
import { useListView } from '../../core/ListViewProvider';
import { useQueryResponse } from '../../core/QueryResponseProvider';
import translations from '../../../../../../../translations/en.json';
import EditPartyLedger from '../../../EditPartyLedger';
import DeletepartyLedger from '../../../DeletePartyLedger';
import { setEditMode } from '../../../../../../../store/editState/actions';

type Props = {
  id: ID;
  message_id: any;
  message_uuid: any;
  data: any;
};

const PartyLedgerActionsCell: FC<Props> = ({ id, message_id, message_uuid, data }) => {
  const { setItemIdForUpdate } = useListView();
  const { refetch } = useQueryResponse();
  const dispatch = useDispatch();
  const [ShowDeletePartyLedgerModal, setShowDeletePartyLedgerModal] = useState(false);
  const [ShowEditMessageModal, setShowEditMessageModal] = useState(false);
  const [isActive, setIsActive] = useState<boolean>(data.istally === 1); // Initialize with istally
  const [loading, setLoading] = useState<any>(false)

  useEffect(() => {
    MenuComponent.reinitialization();
  }, []);

  useEffect(() => {
    // console.log('data.istally on load or change:', data.istally);
    setIsActive(data.istally === 1); // Sync with backend data
  }, [data.istally]);

  const toggleActive = async () => {
    const updatedIstally = isActive ? 0 : 1;
    setIsActive(updatedIstally === 1); // Update local state immediately
    setLoading(true); // Start loading before API call
  
    try {
      const values = {
        istally: updatedIstally,
      };
      console.log('Sending to API:', values);
      const updateData = await TallyLedger(values, id);
      console.log('API Response:', updateData);
  
      if (updateData?.status === 200) {
        refetch();
        dispatch(setMessage('success', updateData?.data?.message ?? updateData?.responseMessage));
      } else {
        dispatch(setMessage('error', updateData?.responseData?.msg || updateData?.responseMessage));
        setIsActive(!isActive); // Revert if failed
      }
    } catch (error) {
      console.error('Error in toggleActive:', error);
      setIsActive(!isActive); // Revert if error
      dispatch(setMessage('error', 'Failed to update tally status'));
    } finally {
      setTimeout(() => {
        setLoading(false); // Stop loading after 2 seconds
      }, 2000);
    }
  };
  

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevents click from bubbling up to row
  };

  const openEditPartyLedgerModal = () => {
    setItemIdForUpdate(message_id);
    alert('test');
  };

  // console.log('Rendering, isActive:', isActive, 'data:', data);

  return (
    <div
      className='d-flex justify-content-end align-items-center menu-gray-600 menu-state-bg-light-primary fw-bold fs-7'
      data-kt-menu='true'
      onClick={handleClick}
      style={{ height: '100%' }}
    >
       {/* Edit Action - Shown only if created_at is today */}
       {data?.is_journal == 1 && (
        <>
          {new Date(data.created_at).toDateString() === new Date().toDateString() && (
            <>
              <span
                style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: '100%', cursor: 'pointer' }}
              >
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip className='py-2 px-2 fs-5'>{translations.labels.edit}</Tooltip>}
                >
                  <i
                    className='fa-sharp fa-solid fa-pen fs-5 text-primary'
                    onClick={() => setShowEditMessageModal(true)}
                    style={{ cursor: 'pointer' }}
                  ></i>
                </OverlayTrigger>
              </span>
              <EditPartyLedger
                show={ShowEditMessageModal}
                handleClose={() => setShowEditMessageModal(false)}
                id={message_id}
                data={data}
              />
            </>
          )}
        </>
      )}
      {/* Checkbox Toggle */}
      {data?.message_id !== 'Opening Balance' &&
        data?.message_id !== 'Current Balance' &&
        data?.message_id !== 'Closing Balance' &&
        data?.message_id !== 'Difference' && (
          <span
            style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: '100%', cursor : 'pointer' }}
            className='ms-3'
          >
            <OverlayTrigger
              placement='bottom'
              overlay={<Tooltip className='py-2 px-2 fs-5'>Is tally</Tooltip>}
            >
              <input
                type='checkbox'
                className='form-check-input border-danger'
                checked={isActive}
                onChange={toggleActive}
                style={{ borderWidth: '2px', width: '22px', height: '22px', cursor: 'pointer' }}
                disabled={loading}
              />
            </OverlayTrigger>
          </span>
        )}

     

      {/* Delete Action - Always visible and clickable */}
      {data?.message_id !== 'Opening Balance' &&
        data?.message_id !== 'Current Balance' &&
        data?.message_id !== 'Closing Balance' &&
        data?.message_id !== 'Difference' && (
          <span
            style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: '100%', cursor: 'pointer' }}
            className='ms-3'
          >
            <OverlayTrigger
              placement='bottom'
              overlay={<Tooltip className='py-2 px-2 fs-5'>Delete</Tooltip>}
            >
              <i
                className='fa-solid fa-trash fs-4 text-danger'
                style={{ cursor: 'pointer' }}
                onClick={() => setShowDeletePartyLedgerModal(true)}
              ></i>
            </OverlayTrigger>
            <DeletepartyLedger
              show={ShowDeletePartyLedgerModal}
              handleClose={() => setShowDeletePartyLedgerModal(false)}
              id={message_id}
            />
          </span>
        )}
    </div>
  );
};

export { PartyLedgerActionsCell };